import { RootState } from "core-integration/src/store";
import { selectIsMyEntry } from "core-integration/src/store/player/reducers";
import { EntryCrestData } from "core-integration/src/store/ui";
import { UnstyledRACButton } from "plos/src/components/buttons/UnstyledRACButton";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CrestPlaceholder } from "../CrestPlaceholder";
import { fluidCrestImg } from "../sharedStyles.css";

interface ControlProps {
  entryCrestData: EntryCrestData;
  onPress?: () => void;
  size?: "sm" | "lg";
}

const CrestPanelControl = ({
  entryCrestData,
  onPress,
  size = "sm",
}: ControlProps) => {
  const { t } = useTranslation();

  const mine = useSelector((state: RootState) =>
    selectIsMyEntry(state, entryCrestData.id),
  );

  const crestSrc = entryCrestData.club_badge_src;

  if (!crestSrc) {
    // Only show button if onPress is provided - I.e. Adobe SDK is enabled
    return onPress ? (
      <UnstyledRACButton onPress={onPress}>
        <CrestPlaceholder size={size} />
      </UnstyledRACButton>
    ) : (
      <CrestPlaceholder size={size} />
    );
  }

  if (crestSrc === "Pending") {
    return <CrestPlaceholder size={size} status="pending" />;
  }

  const img = <img src={crestSrc} alt="" className={fluidCrestImg} />;
  if (mine && onPress) {
    return (
      <UnstyledRACButton
        onPress={onPress}
        aria-label={t("editYourBadge", "Edit your team badge")!}
      >
        {img}
      </UnstyledRACButton>
    );
  }
  return img;
};

export default CrestPanelControl;
